export default __webpack_public_path__ + "static/media/info_4.12db4ad4.jpg";